import {Component, EventEmitter, Input, NgZone, Output} from '@angular/core';
import {Events, Platform, ViewController} from 'ionic-angular';
import {Network} from '@ionic-native/network';
import {COLOR_APP_BACKGROUND_SYNC, COLOR_APP_DANGER, COLOR_CURRENT_STATUS} from '../../app/app.constants';
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";
import {NetworkInformationService} from '../../providers/network.information.service';

@Component({
  selector: 'network-button',
  templateUrl: 'network-button.html'
})
export class NetworkButtonComponent {

  @Input() status: boolean = true;
  @Output() change: EventEmitter<any> = new EventEmitter();
  @Output() onClick: EventEmitter<any> = new EventEmitter();
  mainColor : string = '';
  funHandleSync: any;

  /**
   * component constructor
   * @param {Platform} platform
   * @param {Events} events
   * @param {ViewController} viewCtrl
   * @param {Network} network
   * @param {NgZone} _ngZone
   * @param {NetworkInformationService} networkService
   */
  constructor(private platform: Platform,
              private events: Events,
              private viewCtrl: ViewController,
              private network: Network,
              private _ngZone: NgZone,
              private networkService: NetworkInformationService) {
    this.mainColor = COLOR_CURRENT_STATUS;
    this.viewCtrl.didEnter.subscribe(() => {
      this.subscribeEvents().subscribe();
      const networkStatus = this.networkService.getOnline();
      this._ngZone.run(() => {
        this.mainColor = networkStatus ? COLOR_CURRENT_STATUS : COLOR_APP_DANGER;
      });
    });
    this.viewCtrl.willLeave.subscribe(() => this.unsubscribeEvents());


    // When platform is ready
    this.platform.ready().then(() => {

      // Set initial status
      this.setStatus(navigator.onLine);

      // When entering a view, send status of network
      this.viewCtrl.didEnter.subscribe(() => this.setStatus(navigator.onLine));

      // Subscribe to network connect event
      this.network.onConnect().subscribe(() => {
        this._ngZone.run(() => {
          this.mainColor = COLOR_CURRENT_STATUS;
        });
        this.mainColor = COLOR_CURRENT_STATUS;
        this.setStatus(true)
      });

      // Subscribe to network disconnect event
      this.network.onDisconnect().subscribe(() => {
        this._ngZone.run(() => {
          this.mainColor = COLOR_APP_DANGER;
        });
        this.setStatus(false)
      });

    });
  }

  /**
   * Subscribe to events
   * @returns {any}
   */
  subscribeEvents(){
    return Observable.create((observer: Observer<any>) => {
      this.events.subscribe('backgroundSync:status', this.funHandleSync);
      observer.next(null);
      observer.complete();
    });
  }

  /**
   * Unsubscribe from events
   */
  private unsubscribeEvents(): void {
    this.events.unsubscribe('backgroundSync:status', this.funHandleSync);
  }

  /**
   * Handle the event of SyncBackground
   * @param {boolean} isBackgroundSyncInProgress
   */
  handleSyncBackGround(isBackgroundSyncInProgress: boolean){
    this._ngZone.run(() => {
      this.mainColor = isBackgroundSyncInProgress ? COLOR_APP_BACKGROUND_SYNC : this.status ? COLOR_CURRENT_STATUS: COLOR_APP_DANGER;
    });
  }

  /**
   * Set network status
   * @param {boolean} status
   * @return {void}
   */
  setStatus(status: boolean): void {

    // Set status
    this.status = status;

    this.networkService.setOnline(status);

    // Publish event to parent (requires to bind to event)
    this.change.emit(this.status);

    // Publish event globally (requires to subscribe to event)
    this.events.publish('network:status', this.status);

    // Resize active page's content container because network toolbar will show
    this.viewCtrl.getIONContent().resize();
  }

  /**
   * Click event
   */
  onClickEvent(){
    this.onClick.emit();
  }

  ngOnInit(){
    this.funHandleSync = this.handleSyncBackGround.bind( this );
  }


}



// WEBPACK FOOTER //
// ./src/components/network-button/network-button.ts